"use client";

import React from "react";
import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const packages = [{
  id: 1,
  name: "The Signature Suite",
  price: "€500",
  description: "The definitive standard for luxury property presentation.",
  isPopular: true,
  buttonText: "Secure Your Package",
  link: "/HomePage"
}];
const packageFeatures = [{
  packageId: 1,
  feature: "20 AI-Enhanced Photos"
}, {
  packageId: 1,
  feature: "4K Resolution"
}, {
  packageId: 1,
  feature: "Virtual Staging Options"
}, {
  packageId: 1,
  feature: "Commercial Licensing"
}, {
  packageId: 1,
  feature: "Priority 24h Delivery"
}, {
  packageId: 1,
  feature: "Multi-Language Support"
}];
export default function YourInvestment() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="264640" id="your-investment" className="dark bg-background text-foreground py-24 sm:py-32">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div ref={ref} className={`flex flex-col items-center text-center mb-16 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-light tracking-wider text-foreground mb-4">
            Your Investment
          </h2>
          <p className="text-muted-foreground max-w-2xl text-lg font-default">
            Transparent pricing for transformative results. Elevate your property's digital presence with our all-inclusive premium suite.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
          {}
          <div className="hidden md:block" />
          
          {packages.map((pkg, index) => {
          const features = packageFeatures.filter(f => f.packageId === pkg.id);
          const delay = index * 200;
          return <div key={pkg.id} data-index={index} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${delay}ms`
          }}>
                <Card className={`relative h-full flex flex-col ${pkg.isPopular ? "border-primary/30 shadow-lg ring-1 ring-primary/20 scale-105 z-10 bg-card/95 backdrop-blur-sm" : "border-border shadow-sm bg-card/50"}`}>
                  {pkg.isPopular && <div className="absolute -top-3 left-0 right-0 flex justify-center">
                      <Badge variant="secondary" className="bg-primary text-primary-foreground border-none px-3 py-1 text-xs uppercase tracking-widest font-semibold shadow-md rounded-md">
                        Exclusive Offer
                      </Badge>
                    </div>}

                  <CardHeader className="text-center pb-4 pt-8">
                    <CardTitle className="text-2xl font-default font-medium tracking-wide text-foreground mb-2">
                      {pkg.name}
                    </CardTitle>
                    <div className="mt-4 flex items-baseline justify-center gap-x-2">
                      <span className="text-5xl font-default font-bold tracking-tighter text-primary">
                        {pkg.price}
                      </span>
                    </div>
                    <CardDescription className="mt-4 text-sm text-muted-foreground h-10 font-default">
                      {pkg.description}
                    </CardDescription>
                  </CardHeader>

                  <CardContent className="flex-grow pt-6">
                    <ul className="space-y-4 text-sm text-foreground/80 font-default">
                      {features.map((feature, fIndex) => <li key={fIndex} data-index={fIndex} className="flex items-start gap-3">
                          <Check className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                          <span className="tracking-wide">{feature.feature}</span>
                        </li>)}
                    </ul>
                  </CardContent>

                  <CardFooter className="pt-6 pb-8">
                    <Button asChild variant={pkg.isPopular ? "default" : "outline"} className={`w-full rounded-md py-6 text-lg font-default tracking-wide transition-all duration-300 ${pkg.isPopular ? "bg-primary text-primary-foreground hover:bg-primary/90 shadow-md" : "border-border text-foreground hover:bg-accent hover:text-accent-foreground"}`}>
                      <Link to={pkg.link}>{pkg.buttonText}</Link>
                    </Button>
                  </CardFooter>
                </Card>
              </div>;
        })}
          
          <div className="hidden md:block" />
        </div>
      </div>
    </section>;
}